import Layout from "@/layouts/index.vue";

const routes = [
  {
    path: "/site",
    meta: { title: "站点" },
    redirect: "/site/list",
    component: Layout,
    children: [
      {
        path: "/site/list",
        meta: {
          title: "站点列表",
          icon: "icon-jingdian",
          parentPath: "/site",
        },
        component: () => import("@/views/site/site/index.vue"),
      },
    ],
  },
];

export default routes;
